module.exports = __webpack_public_path__ + "0ef1f8b893c81e986fef643fa5c23556.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/pic3.png
// module id = 1862
// module chunks = 0